const $inject = ['$filter', 'moment', 'settingsService', 'ENUMS', 'dateTimeService'];

const lostSavingsService = function lostSavingsService($filter, moment, settingsService, ENUMS, dateTimeService) {
  let service = {
    getMessage: getMessage,
  };

  function getMessage(policyExceptionDetails) {
    const p = policyExceptionDetails;
    const currencyCode = settingsService.currencyCode();
    const timeFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
    const priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);
    const minimumTimeOfCheapestOption = moment(p.MinimumTimeOfCheapestOption, 'HH:mm').format(timeFormat);
    const maximumTimeOfCheapestOption = moment(p.MaximumTimeOfCheapestOption, 'HH:mm').format(timeFormat);

    let message = '';

    if (p.MultipleCheapestOptions) {
      const flightText = p.IsCombinableFare ? 'combinable flights' : 'flights';

      if (p.MinimumTimeOfCheapestOption === p.MaximumTimeOfCheapestOption) {
        message = `There were multiple cheaper ${flightText} departing at ${minimumTimeOfCheapestOption} for ${priceCheapestOption}${currencyCode}`;
      } else {
        message = `There were multiple cheaper ${flightText} departing between ${minimumTimeOfCheapestOption} and ${maximumTimeOfCheapestOption}, at ${priceCheapestOption} ${currencyCode}`;
      }
    } else {
      if (p.IsCombinableFare) {
        message = `Flight ${p.NameOfCheapestOption} departs at ${maximumTimeOfCheapestOption} and has a cheaper combinable option at ${priceCheapestOption}${currencyCode}`;
      } else {
        message = `Flight ${p.NameOfCheapestOption} departs at ${maximumTimeOfCheapestOption} and is cheaper at ${priceCheapestOption}${currencyCode}`;
      }
    }

    return message;
  }

  return service;
};

lostSavingsService.$inject = $inject;

export default lostSavingsService;



// WEBPACK FOOTER //
// ./src/services/lostSavingsService.js